import {colorToHex} from '../api/color';

function project(state = {}, action) {
    let i =0;
    switch(action.type) {
        case 'CREATE_DATA' :
            action.payload.data.color = colorToHex(action.payload.data.color);
            return Object.assign({},state,{'openModal':false,'data': [action.payload.data,...state.data]});

        case 'CHANGE_ACTIVATION':
            const pId = action.payload.data.id.trim();
            let index = -1;
            for(i=0;i<state.data.length;i++) {
                if(state.data[i].id.trim() === pId) index=i;
            }
            return Object.assign({},state,{'data': [...state.data.slice(0,index),action.payload.data,...state.data.slice(index+1)]});
        
        case 'UPDATE_DATA' :
            action.payload.data.color = colorToHex(action.payload.data.color);
            return Object.assign({},state,{'openModal':false,'data': [...state.data.slice(0,state.objNumber),action.payload.data,...state.data.slice(state.objNumber+1)]});
        
        case 'CHANGE_COLOR_PICKER_STATUS' :
            return Object.assign({},state,{'colorPicker': !state.colorPicker});
        
        case 'CLOSE_COLOR_PICKER' :
            return Object.assign({},state,{'colorPicker': false});
        
        case 'FETCH_DATA_SUCCESS' :
            // converting colors type
            for(i=0;i<action.payload.data.list.length;i++) action.payload.data.list[i].color = colorToHex(action.payload.data.list[i].color);
            return Object.assign({},state,{'data': action.payload.data.list,'fetched': true});
        
        case 'CLOSE_MODAL' :
            return Object.assign({},state,{'openModal': false, 'objNumber': -1,'readOnly': true});
        
        default:
          return state;
    }
}

export default project;